// extracted by mini-css-extract-plugin
module.exports = {"versionHistory":"VersionHistory_versionHistory__WY4g_","spinnerContainer":"VersionHistory_spinnerContainer__HUa4E"};